import { ValidatorOptions } from "./Index";
import i18n from '../helpers/i18n';

export function required(options: ValidatorOptions = new ValidatorOptions()) {
    return {
        options: options,
        validate: (value: any) => {
            let hasError = !value;

            if (Array.isArray(value)) {
                hasError = value.length === 0;
            }

            return {
                hasError: hasError,
                errorMessage: i18n.t("Field is required")
            };
        }
    }
}